export type AppErrorCode = 'FORBIDDEN' | 'LOCAL_CONFIGURATION_INVALID' | 'NOT_FOUND' | 'UNEXPECTED_ERROR'

export class AppError extends Error {
  public readonly code: AppErrorCode
  public readonly details: Readonly<Record<string, unknown>> | undefined

  public constructor(code: AppErrorCode, message: string, details?: Readonly<Record<string, unknown>>) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.details = details
  }
}
